exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.muted[data-v-a28e6970]{color:#999;}\n.mono[data-v-a28e6970]{font-family:Consolas,monospace;}\n.text-red[data-v-a28e6970]{color:#f5222d;}\n", ""]);

// exports
